import { createAsyncThunk } from '@reduxjs/toolkit';
import { HELPDESK } from '../../routes/routes';

import {
  getCategoryWithQuestionAsync,
  getQuestionAsync,
  getSupportCategoriesAsync,
  searchQuestionAsync
} from './helpDesk.requests';

interface GetSupportCategoriesPropsType {
  history: {
    push(url: string): void;
  };
  match: any;
}

export const getSupportCategories = createAsyncThunk(
  'auth/getSupportCategories',
  async ({ history, match }: GetSupportCategoriesPropsType) => {
    const categories = await getSupportCategoriesAsync();

    const category = await getCategoryWithQuestionAsync(
      match.params.categoryId ? match.params.categoryId : categories[0]?.id
    );

    // if (isTrue) {
    //   match.params.categoryId
    //     ? history.push(`${HELPDESK}/${match.params.categoryId}`)
    //     : history.push(`${HELPDESK}/${category.id}`);
    // }

    return {
      categories,
      category
    };
  }
);

export const getCategoryWithQuestion = createAsyncThunk(
  'auth/getCategoryWithQuestion',
  async (id: string) => {
    const category = await getCategoryWithQuestionAsync(id);
    return category;
  }
);

export const getSubCategoryWithQuestion = createAsyncThunk(
  'auth/getSubCategoryWithQuestion',
  async (id: string) => {
    const subCategory = await getCategoryWithQuestionAsync(id);
    return subCategory;
  }
);

export const getQuestion = createAsyncThunk(
  'auth/getQuestion',
  async (id: string) => {
    return await getQuestionAsync(id);
  }
);

export const searchQuestion = createAsyncThunk(
  'auth/searchQuestion',
  async (search: string) => {
    return await searchQuestionAsync(search);
  }
);
